// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__NWjQg","title":"Header_title__1eT2Q","side":"Header_side__ErT3z"};